/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface RequestPasswordResetBody
 */
export interface RequestPasswordResetBody {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordResetBody
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof RequestPasswordResetBody
     */
    phoneNumber?: PhoneNumberBody;
}

/**
 * Check if a given object implements the RequestPasswordResetBody interface.
 */
export function instanceOfRequestPasswordResetBody(value: object): value is RequestPasswordResetBody {
    return true;
}

export function RequestPasswordResetBodyFromJSON(json: any): RequestPasswordResetBody {
    return RequestPasswordResetBodyFromJSONTyped(json, false);
}

export function RequestPasswordResetBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPasswordResetBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
    };
}

export function RequestPasswordResetBodyToJSON(json: any): RequestPasswordResetBody {
    return RequestPasswordResetBodyToJSONTyped(json, false);
}

export function RequestPasswordResetBodyToJSONTyped(value?: RequestPasswordResetBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
    };
}

